import React from "react";
import { MoreHorizontal } from "lucide-react";

export default function ConversationOptionsButton({ onClick, ariaLabel = "Conversation options" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="h-9 w-9 shrink-0 rounded-xl border border-white/12 bg-white/[0.04] hover:bg-white/[0.08] transition flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white/25"
    >
      <MoreHorizontal className="text-white/80" size={18} />
    </button>
  );
}
